import React from 'react'
import { connect } from 'react-redux'
import { selectProjectAction, migrateLegacyProject } from 'actions/projectActions'
import { SELECT_PROJECT } from 'actions/projectActionTypes'
import { notificationAction } from 'actions/notificationActions'
import compose from 'ramda/src/compose'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import pathEq from 'ramda/src/pathEq'
import timeAgo from 'helpers/timeAgo'
import { projectListSelector, deviceCountSelector } from 'selectors/components'
import Fuse from 'fuse.js'

const mapStateToProps = state => {
  const { cameraModels, notification,  currentProjectMetadata } = state

  return {
    projects: projectListSelector(state),
    cameraModels,
    notification,
    currentProjectId: currentProjectMetadata ? currentProjectMetadata._id : null,
    currentDeviceCount: currentProjectMetadata && deviceCountSelector(state)
  }
}

class ListItem extends React.Component {
  state = { selected: false }

  componentWillReceiveProps(nextProps) {
    if (this.state.selected && this.props.notification !== nextProps.notification && pathEq(['notification', 'type'], SELECT_PROJECT)(nextProps)) {
      clearInterval(global.modelLoadInterval)
      this.setState({ selected: false })
      this.props.setChosen(false)
    }
  }

  handleClick = p => {
    const { migrateOrSelectProject, props: { cameraModels, projectChosen, setChosen, notificationAction } } = this
    if (projectChosen) return

    this.setState({ selected: true })
    setChosen(true)

    if (cameraModels) {
      migrateOrSelectProject(p)
    } else {
      global.modelLoadInterval = setInterval((_ => {
        if (this.props.cameraModels) {
          migrateOrSelectProject(p)
          clearInterval(global.modelLoadInterval)
        }
      }).bind(this), 100)

      setTimeout((_ => {
        if (!this.props.cameraModels) {
          clearInterval(global.modelLoadInterval)
          this.setState({ selected: false })
          setChosen(false)
          notificationAction('Camera data not loaded: check connection')
        }
      }).bind(this), 30000)
    }
  }

  migrateOrSelectProject = p => {
    const { selectProjectAction, migrateLegacyProject } = this.props
    p.legacyId ? migrateLegacyProject(p) : selectProjectAction(p.id)
  }

  componentWillUnmount = _ => {
    clearInterval(global.modelLoadInterval)
  }

  render() {
    const { handleClick, state: { selected }, props: { project, currentProjectId, currentDeviceCount, classes } } = this

    return (
      selected
      ? <div className={classes.row}>
          <div className={classes.loading}>
            <FontAwesomeIcon icon='spinner' className={`${classes.loadingButton} fa-spin`} />
          </div>
        </div>
      : <div className={classes.row} onClick={handleClick.bind(this, project)}>
          <div style={{ flex: 1 }}>
            <div>
              { project.title }
            </div>
            <div className={classes.info}>
              <span>Devices: {project.id === currentProjectId ? currentDeviceCount : project.deviceCount}</span>
              <span>{timeAgo(project.updatedAt)}</span>
            </div>
          </div>
          <FontAwesomeIcon icon='arrow-right' className={classes.rightArrow} />
        </div>
    )
  }
}

class ProjectList extends React.Component {
  state = { filter: '', projectChosen: false }

  constructor(props) {
    super(props)
    const options = {
      threshold: 0.3,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      shouldSort: false,
      includeScore: false,
      isCaseSensitive: false,
      keys: ['title']
    }
    this.fuse = new Fuse(this.props.projects, options)
  }

  updateFilter = ({ target: { value } }) => {
    this.setState({ filter: value })
  }

  filterProjects = projects => {
    const { state: { filter } } = this
    if (filter === '') return projects
    return this.fuse.search(filter)
  }

  sortProjects = projects =>
    projects.sort((a,b) => b.updatedAt - (a.updatedAt || 0))

  getProjects = _ => {
    const { sortProjects, filterProjects, props: { projects } } = this
    if (!projects) return projects
    return compose(sortProjects, filterProjects)(projects)
  }

  updateProjectChosen = choice =>
    this.setState({ projectChosen: choice })

  render() {
    const { state: { filter, projectChosen }, getProjects, updateProjectChosen, props: { showNewProject, classes } } = this
    const projects = getProjects()

    if (!projects) {
      return (
        <div className={classes.loading}>
          <FontAwesomeIcon icon='spinner' className={`${classes.locationButton} fa-spin`} />
          Loading Projects...
        </div>
      )
    }

    return (
      <div className={classes.projectList}>
        <div className={classes.header}>
          All Projects
        </div>
        <div className={classes.searchWrapper}>
          <input type='search' onChange={this.updateFilter} onKeyPress={e => e.key === 'Enter' && e.target.blur()} value={filter} placeholder='Search...' className={classes.searchInput} />
          <FontAwesomeIcon icon='search' className={classes.searchIcon} />
        </div>
        <div className={classes.projectsWrapper}>
          {
            projects.length === 0
            ? <div>
                <p className={classes.notFoundText}>No projects found</p>
                <div className={classes.newProjectButton} onClick={showNewProject}>
                  Create a new project now
                  <FontAwesomeIcon icon='arrow-right' className={classes.whiteArrow} />
                </div>
              </div>
            : projects.map(project => <ListItem {...this.props} project={project} projectChosen={projectChosen} setChosen={updateProjectChosen.bind(this)} key={project.id} />)
          }
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, { migrateLegacyProject, selectProjectAction, notificationAction })(injectSheet(style)(ProjectList))



// WEBPACK FOOTER //
// ./src/components/MobileStart/ProjectList/index.js